export const sendSberAdsEvent = (eventName: string) => {
  if (process.env.NEXT_PUBLIC_DEPLOY_ENV === 'prod') {
    window.ym?.(94774691, 'reachGoal', eventName);
  } else {
    console.info('Dev event:', eventName);
  }
};
